import { useSearchParams } from 'react-router-dom';
import AdvancedSearch from '../components/AdvancedSearch';

const Search = () => {
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get('q') || '';

  return <AdvancedSearch initialQuery={initialQuery} />;
};

export default Search;
